import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DtgDriverInfo } from "../../shared/vo/dtg.driver.info";
import { FvmsApiBaseService } from "./fvms.api.base.service";
import { PagingInfo } from "src/app/shared/vo/fvms.paging.info";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgDriverService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getDriverList(searchInfo:DtgDriverInfo, pagingInfo:PagingInfo):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/driver";
        url += "/list";


        let param = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        return this.http.post<any>(url,param);
    }

    updateDriverInfo(dtgDriverInfo:DtgDriverInfo):Observable<any>{
        let param = {
            "searchInfo":dtgDriverInfo
            ,"pagingInfo":null
        };
        let url = this.getApiBaseUrl() + "/dtg/driver";
        url += "/updateDriverInfo";

        return this.http.post<any>(url,param);
    }
}